import { render, staticRenderFns } from "./TaskGroupsModifyDeadlineDialog.vue?vue&type=template&id=c97748b2&"
import script from "./TaskGroupsModifyDeadlineDialog.vue?vue&type=script&lang=js&"
export * from "./TaskGroupsModifyDeadlineDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports